import { render } from "./QuickpayPaymentOverviewCard.vue?vue&type=template&id=b15f4052&scoped=true"
import script from "./QuickpayPaymentOverviewCard.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentOverviewCard.vue?vue&type=script&lang=js"

import "./QuickpayPaymentOverviewCard.vue?vue&type=style&index=0&id=b15f4052&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b15f4052"]])

export default __exports__